import React from 'react';

const WrenchBold = ({
  width = '16',
  height = '16',
  fill = '#000',
  ...props
}) => (
<svg xmlns="http://www.w3.org/2000/svg" width={width}
     height={height} viewBox="0 0 16 16" fill="none" {...props}>
  <g clipPath="url(#clip0_631_19003)">
    <path d="M10.4502 1.00001C9.79298 0.99995 9.14355 1.14227 8.54658 1.41717C7.94962 1.69207 7.41929 2.09304 6.99209 2.59248C6.56489 3.09192 6.25096 3.67798 6.0719 4.31034C5.89283 4.9427 5.85289 5.60634 5.95481 6.25561L1.78421 10.4248C1.28146 10.9276 0.999023 11.6094 0.999023 12.3204C0.999023 13.0314 1.28146 13.7133 1.78421 14.216C2.28695 14.7188 2.96882 15.0012 3.67981 15.0012C4.39079 15.0012 5.07266 14.7188 5.57541 14.216L9.74461 10.0468C10.418 10.1524 11.1065 10.1054 11.7593 9.90922C12.4121 9.71302 13.0125 9.37267 13.516 8.9133C14.0196 8.45393 14.4136 7.88729 14.6688 7.25523C14.924 6.62317 15.0339 5.94186 14.9904 5.26161C14.983 5.14295 14.9455 5.02813 14.8814 4.92798C14.8173 4.82783 14.7288 4.74565 14.6241 4.6892C14.5195 4.63274 14.4022 4.60387 14.2833 4.60531C14.1644 4.60675 14.0479 4.63845 13.9446 4.69741L10.9178 6.42641L9.57381 5.08241L11.3042 2.05561C11.3635 1.95233 11.3955 1.83562 11.3971 1.71654C11.3987 1.59745 11.3699 1.47993 11.3134 1.37508C11.2569 1.27024 11.1746 1.18154 11.0743 1.11737C10.9739 1.05321 10.8589 1.01571 10.74 1.00841C10.6435 1.00258 10.5469 0.999774 10.4502 1.00001Z" fill={fill}/>
  </g>
  <defs>
    <clipPath id="clip0_631_19003">
      <rect width="14" height="14" fill="white" transform="translate(1 1)"/>
    </clipPath>
  </defs>
</svg>
);

export default WrenchBold;
